// extracted by mini-css-extract-plugin
var _1 = "SettingsSwitch-moduleSettingsSwitch__jmOF8";
export { _1 as "SettingsSwitch" }
